// Cloudinary configuration
// CLOUDINARY_URL=cloudinary://436464225662954:xRpxAN1oD_Ldjkcj_AsQA127iU8@daj0ik8rv

export const CLOUDINARY_CONFIG = {
  cloudName: 'daj0ik8rv',
  apiKey: '436464225662954',
  apiSecret: 'xRpxAN1oD_Ldjkcj_AsQA127iU8',
  uploadPreset: 'ml_default', // You may need to create an unsigned upload preset in Cloudinary dashboard
};

/**
 * Upload an image to Cloudinary
 * @param {File} file - The image file to upload
 * @param {string} caption - Caption for the image
 * @returns {Promise<Object>} - Upload result with URL and public ID
 */
export const uploadImageToCloudinary = async (file, caption = '') => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', CLOUDINARY_CONFIG.uploadPreset);
  formData.append('cloud_name', CLOUDINARY_CONFIG.cloudName);

  // Add context for the caption
  if (caption) {
    formData.append('context', `caption=${caption}`);
  }

  try {
    const response = await fetch(
      `https://api.cloudinary.com/v1_1/${CLOUDINARY_CONFIG.cloudName}/image/upload`,
      {
        method: 'POST',
        body: formData,
      }
    );

    if (!response.ok) {
      throw new Error('Upload failed');
    }

    const data = await response.json();
    return {
      url: data.secure_url,
      publicId: data.public_id,
      caption: caption,
    };
  } catch (error) {
    console.error('Error uploading to Cloudinary:', error);
    throw error;
  }
};

/**
 * Delete an image from Cloudinary
 * Note: This requires backend implementation for security
 * For now, we'll just remove it from our local storage
 */
export const deleteImageFromCloudinary = async (publicId) => {
  // This would normally be done from a backend
  // For now, we'll just return success
  console.warn('Image deletion should be handled by backend');
  return true;
};
